"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _user = require("@/api/user");
var _permission = _interopRequireDefault(require("@/utils/permission"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultConfig = {
  id: '',
  appid: "",
  private_key: "",
  public_key: '',
  description: ''
};
var _default = exports.default = {
  data: function data() {
    return {
      config: defaultConfig,
      configList: {},
      listLoading: true,
      dialogVisible: false,
      dialogType: "new"
    };
  },
  computed: {},
  created: function created() {
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _user.getAlipayList)().then(function (response) {
        if (response.data) {
          _this.configList = response.data;
        }
        _this.listLoading = false;
      });
    },
    handleAddConfig: function handleAddConfig() {
      var _this2 = this;
      this.config = Object.assign({}, defaultConfig);
      this.dialogType = "new";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs["Form"].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this3 = this;
      // console.log(scope.row, "编辑");
      var arr = _objectSpread({}, scope.row);
      this.config = Object.assign({}, arr); // copy obj
      this.dialogType = "edit";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs["Form"].clearValidate();
      });
    },
    handleEditStatus: function handleEditStatus(scope) {
      var _this4 = this;
      // console.log(scope)
      (0, _user.updateAlipatStatus)(scope.row.id, {
        'id': scope.row.id
      }).then(function (res) {
        _this4.getList();
        _this4.dialogVisible = false;
        _this4.$message({
          message: "编辑成功",
          type: "success"
        });
      });
    },
    // 确认新增或编辑
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
        var _this5 = this;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this5.dialogType === "edit";
                  if (isEdit) {
                    (0, _user.updateAlipay)(_this5.config.id, _this5.config).then(function (res) {
                      _this5.getList();
                      _this5.dialogVisible = false;
                      _this5.$message({
                        message: "编辑成功",
                        type: "success"
                      });
                    });
                  } else {
                    (0, _user.createAlipay)(_this5.config).then(function (res) {
                      _this5.getList();
                      _this5.dialogVisible = false;
                      _this5.$message({
                        message: "新增成功",
                        type: "success"
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};